
import { UserRole } from "@/types";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Lock, Mail, Shield } from "lucide-react";

interface UserInfoCardProps {
  user: {
    id: string;
    nome: string;
    email: string;
    profilePicture?: string;
    role: UserRole;
  };
  onPasswordChange: () => void;
}

export const UserInfoCard = ({ user, onPasswordChange }: UserInfoCardProps) => {
  return (
    <Card className="shadow-sm border-gray-200">
      <CardHeader className="pb-4 text-center">
        <div className="flex justify-center">
          <Avatar className="h-24 w-24 border-2 border-white shadow-md">
            <AvatarImage src={user.profilePicture || ""} alt={user.nome} />
            <AvatarFallback className="bg-primary text-white text-xl">
              {user.nome ? user.nome.substring(0, 2).toUpperCase() : "US"}
            </AvatarFallback>
          </Avatar>
        </div>
        <CardTitle className="mt-4">{user.nome}</CardTitle>
        <CardDescription className="flex items-center justify-center gap-1 mt-1">
          <Shield className="h-3.5 w-3.5" />
          {user.role === UserRole.ADMIN ? "Administrador" : 
           user.role === UserRole.PARCEIRO ? "Parceiro" : "Vendedor"}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3 text-sm">
          <div className="flex items-start gap-3">
            <Mail className="h-4 w-4 text-gray-500 mt-0.5" />
            <div>
              <p className="font-medium text-gray-700">Email</p>
              <p className="text-gray-600">{user.email}</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Shield className="h-4 w-4 text-gray-500 mt-0.5" />
            <div>
              <p className="font-medium text-gray-700">Tipo de Conta</p>
              <p className="text-gray-600">
                {user.role === UserRole.ADMIN ? "Administrador" : 
                 user.role === UserRole.PARCEIRO ? "Parceiro" : "Vendedor"}
              </p>
            </div>
          </div>
        </div>
      </CardContent>
      <CardFooter className="border-t px-6 py-4 flex justify-center">
        <Button 
          variant="outline" 
          onClick={onPasswordChange}
          className="w-full flex items-center gap-2"
        >
          <Lock className="h-4 w-4" />
          Alterar Senha
        </Button>
      </CardFooter>
    </Card>
  );
};
